import * as angular from "angular";

export class EmploymentStatusService {
    private readonly apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/employmentstatus";
    }

    all(): Promise<object> {
        return this.$http.get(this.apiRoot + "/statuses");
    }
}

angular
    .module("vcServices")
    .service("EmploymentStatusService", EmploymentStatusService);
